import React from 'react';
import { Star, Quote } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TeamBanner from '../components/Team/teambanner';
import TeamMembers from '../components/Team/member';
import Mission from "../components/Home/mission";
import { CheckCircle, Mail, MapPin, Briefcase, Zap } from "lucide-react";
  
function TeamPage() {
  return (
    <>
    <Header/>
    <TeamBanner/>
    <TeamMembers/>
 <Mission/>
    <Footer/>
    </>
    
  );
};

export default TeamPage;